// frontend/src/pages/admin/ManageAppsPage.js
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash, FaPlus, FaCheckCircle, FaDesktop, FaCheckDouble } from 'react-icons/fa';

const ManageAppsPage = () => {
  const [apps, setApps] = useState([]);
  const [users, setUsers] = useState([]); 
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingApp, setEditingApp] = useState(null);
  const [msg, setMsg] = useState(null);

  const initialForm = { name: '', description: '', price: 0, loginCredential: { username: '', password: '' }, iconUrl: '', isActive: true, allowedUserIds: [] };
  const [formData, setFormData] = useState(initialForm);

  const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';

  const getCleanToken = () => {
      let token = localStorage.getItem('token');
      return token ? token.replace(/"/g, '') : null;
  };

  const fetchData = useCallback(async () => {
    try {
        const token = getCleanToken();
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const [appsRes, usersRes] = await Promise.all([
            axios.get(`${API_URL}/subscriptions`, config),
            axios.get(`${API_URL}/users`, config)
        ]);
        setApps(appsRes.data);
        setUsers(usersRes.data);
        setLoading(false);
    } catch (error) { setLoading(false); }
  }, [API_URL]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleOpenModal = (app = null) => {
      setEditingApp(app);
      setFormData(app ? { ...app, allowedUserIds: app.allowedUserIds.map(u => u._id || u) } : initialForm);
      setModalOpen(true);
  };

  const handleSubmit = async (e) => {
      e.preventDefault();
      const token = getCleanToken();
      const config = { headers: { Authorization: `Bearer ${token}` } };

      try {
          if (editingApp) {
              // DÜZELTİLDİ: POST tünelleme
              await axios.post(`${API_URL}/subscriptions/${editingApp._id}?_method=PUT`, formData, config);
              setMsg({ type: 'success', text: 'Abonelik güncellendi.' });
          } else {
              await axios.post(`${API_URL}/subscriptions`, formData, config);
              setMsg({ type: 'success', text: 'Abonelik eklendi.' });
          }
          setModalOpen(false);
          fetchData();
      } catch (error) { setMsg({ type: 'error', text: 'İşlem başarısız.' }); }
  };

  const handleDelete = async (id) => {
      if(!window.confirm("Silmek istediğinize emin misiniz?")) return;
      const token = getCleanToken();
      try {
          // DÜZELTİLDİ: POST tünelleme
          await axios.post(`${API_URL}/subscriptions/${id}?_method=DELETE`, {}, { headers: { Authorization: `Bearer ${token}` } });
          setMsg({ type: 'success', text: 'Silindi.' });
          fetchData();
      } catch (error) { setMsg({ type: 'error', text: 'Silinemedi.' }); }
  };

  const toggleUser = (userId) => {
      const currentIds = formData.allowedUserIds || [];
      if (currentIds.includes(userId)) setFormData({ ...formData, allowedUserIds: currentIds.filter(id => id !== userId) });
      else setFormData({ ...formData, allowedUserIds: [...currentIds, userId] });
  };

  const toggleAllUsers = () => {
      const currentIds = formData.allowedUserIds || [];
      if (currentIds.length === users.length) setFormData({ ...formData, allowedUserIds: [] });
      else setFormData({ ...formData, allowedUserIds: users.map(u => u._id) });
  };

  if (loading) return <div className="p-10 text-white animate-pulse">Yükleniyor...</div>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-white">Abonelik Yönetimi</h1>
        <button onClick={() => handleOpenModal()} className="bg-primary hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2"><FaPlus /> Yeni Ekle</button>
      </div>
      {msg && <div className={`p-3 rounded-lg border ${msg.type === 'success' ? 'bg-green-500/20 border-green-500/50 text-green-400' : 'bg-red-500/20 border-red-500/50 text-red-400'}`}>{msg.text}</div>}
      
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {apps.map(app => (
              <div key={app._id} className="bg-surface border border-border rounded-xl p-5 relative group">
                  <div className="flex justify-between items-start mb-4">
                      <div className="flex items-center gap-3">
                          <div className="w-12 h-12 bg-gray-800 rounded-lg flex items-center justify-center text-2xl">{app.iconUrl ? <img src={app.iconUrl} className="w-8 h-8 object-contain" alt="icon"/> : <FaDesktop className="text-gray-500"/>}</div>
                          <div><h3 className="font-bold text-white text-lg">{app.name}</h3><p className="text-xs text-primary font-bold">₺{app.price} / Ay</p></div>
                      </div>
                      <div className={`px-2 py-1 rounded text-[10px] font-bold ${app.isActive ? 'bg-green-500/10 text-green-400' : 'bg-red-500/10 text-red-400'}`}>{app.isActive ? 'AKTİF' : 'PASİF'}</div>
                  </div>
                  <div className="space-y-2 text-sm text-text-secondary mb-4">
                      <p><span className="font-bold text-gray-500">Kullanıcı:</span> {app.loginCredential?.username}</p>
                      <p><span className="font-bold text-gray-500">Şifre:</span> {app.loginCredential?.password}</p>
                      <p><span className="font-bold text-gray-500">Atanan:</span> {app.allowedUserIds?.length || 0} Kişi</p>
                  </div>
                  <div className="flex gap-2 border-t border-border pt-3">
                      <button onClick={() => handleOpenModal(app)} className="flex-1 bg-blue-600/10 hover:bg-blue-600 text-blue-500 hover:text-white py-2 rounded text-sm font-bold flex items-center justify-center gap-2"><FaEdit /> Düzenle</button>
                      <button onClick={() => handleDelete(app._id)} className="flex-1 bg-red-600/10 hover:bg-red-600 text-red-500 hover:text-white py-2 rounded text-sm font-bold flex items-center justify-center gap-2"><FaTrash /> Sil</button>
                  </div>
              </div>
          ))}
      </div>

      {modalOpen && (
          <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
              <div className="bg-surface border border-border p-6 rounded-xl w-full max-w-2xl shadow-2xl max-h-[90vh] overflow-y-auto">
                  <h2 className="text-xl font-bold text-white mb-6">{editingApp ? 'Abonelik Düzenle' : 'Yeni Abonelik Ekle'}</h2>
                  <form onSubmit={handleSubmit} className="space-y-4">
                      <div className="grid grid-cols-2 gap-4">
                          <div><label className="block text-xs font-bold text-text-secondary mb-1">Uygulama Adı</label><input type="text" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} className="w-full bg-background border border-border rounded p-2 text-white outline-none" required /></div>
                          <div><label className="block text-xs font-bold text-text-secondary mb-1">Aylık Ücret (TL)</label><input type="number" value={formData.price} onChange={e => setFormData({...formData, price: Number(e.target.value)})} className="w-full bg-background border border-border rounded p-2 text-white outline-none" required /></div>
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                          <div><label className="block text-xs font-bold text-text-secondary mb-1">Giriş E-Posta / Kullanıcı Adı</label><input type="text" value={formData.loginCredential.username} onChange={e => setFormData({...formData, loginCredential: {...formData.loginCredential, username: e.target.value}})} className="w-full bg-background border border-border rounded p-2 text-white outline-none" required /></div>
                          <div><label className="block text-xs font-bold text-text-secondary mb-1">Giriş Şifresi</label><input type="text" value={formData.loginCredential.password} onChange={e => setFormData({...formData, loginCredential: {...formData.loginCredential, password: e.target.value}})} className="w-full bg-background border border-border rounded p-2 text-white outline-none" required /></div>
                      </div>
                      <div><label className="block text-xs font-bold text-text-secondary mb-1">Açıklama</label><textarea value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} className="w-full bg-background border border-border rounded p-2 text-white outline-none h-20"></textarea></div>
                      <div className="grid grid-cols-2 gap-4">
                           <div><label className="block text-xs font-bold text-text-secondary mb-1">İkon URL</label><input type="text" value={formData.iconUrl} onChange={e => setFormData({...formData, iconUrl: e.target.value})} placeholder="https://..." className="w-full bg-background border border-border rounded p-2 text-white outline-none" /></div>
                           <div className="flex items-end"><label className="flex items-center gap-2 cursor-pointer bg-gray-800 p-2 rounded w-full hover:bg-gray-700 transition-colors"><input type="checkbox" checked={formData.isActive} onChange={e => setFormData({...formData, isActive: e.target.checked})} className="w-5 h-5 accent-primary" /><span className={`text-sm font-bold ${formData.isActive ? 'text-green-400' : 'text-red-400'}`}>{formData.isActive ? 'AKTİF' : 'PASİF'}</span></label></div>
                      </div>
                      <div className="border-t border-border pt-4">
                          <div className="flex justify-between items-center mb-2">
                              <label className="block text-sm font-bold text-white">Bu Uygulamayı Kimler Kullanabilir?</label>
                              <button type="button" onClick={toggleAllUsers} className="text-xs font-bold text-primary hover:text-white flex items-center gap-1"><FaCheckDouble /> {formData.allowedUserIds?.length === users.length ? 'Tümünü Kaldır' : 'Tümünü Seç'}</button>
                          </div>
                          <div className="grid grid-cols-2 md:grid-cols-3 gap-2 max-h-40 overflow-y-auto custom-scrollbar p-2 bg-background rounded-lg border border-border">
                              {users.map(u => (
                                  <label key={u._id} className={`flex items-center gap-2 p-2 rounded cursor-pointer transition-colors ${formData.allowedUserIds?.includes(u._id) ? 'bg-primary/20 border border-primary/50' : 'hover:bg-gray-800'}`}>
                                      <input type="checkbox" checked={formData.allowedUserIds?.includes(u._id)} onChange={() => toggleUser(u._id)} className="hidden" />
                                      <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${formData.allowedUserIds?.includes(u._id) ? 'border-primary bg-primary' : 'border-gray-500'}`}>{formData.allowedUserIds?.includes(u._id) && <FaCheckCircle className="text-white text-[10px]" />}</div>
                                      <span className="text-xs text-white truncate">{u.name}</span>
                                  </label>
                              ))}
                          </div>
                      </div>
                      <div className="flex gap-3 pt-2">
                          <button type="submit" className="flex-1 bg-primary hover:bg-blue-600 text-white py-3 rounded-lg font-bold transition-colors">Kaydet</button>
                          <button type="button" onClick={() => setModalOpen(false)} className="flex-1 bg-gray-700 hover:bg-gray-600 text-white py-3 rounded-lg font-bold transition-colors">İptal</button>
                      </div>
                  </form>
              </div>
          </div>
      )}
    </div>
  );
};

export default ManageAppsPage;